import type { MachineDetailTab } from '../../contexts/machineDetailTabs';
import type { Machine } from '../../gql/generated';
import {
  ejectorSource,
  healthSignals,
  sortingSource,
} from './machineDataSources';
import { MachineDocumentsLinkTab } from './MachineDocumentsLinkTab';
import { MachineHealthDataTab } from './MachineHealthDataTab';
import { MachineSortingDataTab } from './MachineSortingDataTab';

/**
 * The tabs a machine's own EDMS data fills, around Pulse's own tabs: Sorting
 * and Health before them, Documents after. A tab only shows when the machine
 * reports its data.
 */
export function machineDataTabs(machine: Machine): {
  leading: MachineDetailTab[];
  trailing: MachineDetailTab[];
} {
  const leading: MachineDetailTab[] = [];
  if (sortingSource(machine)) {
    leading.push({
      value: 'sorting',
      label: 'Sorting',
      render: (m) => <MachineSortingDataTab machine={m} />,
    });
  }
  if (healthSignals(machine).length > 0 || ejectorSource(machine)) {
    leading.push({
      value: 'health',
      label: 'Health',
      render: (m) => <MachineHealthDataTab machine={m} />,
    });
  }

  const trailing: MachineDetailTab[] = machine.serial
    ? [
        {
          value: 'documents',
          label: 'Documents',
          render: (m) => <MachineDocumentsLinkTab machine={m} />,
        },
      ]
    : [];

  return { leading, trailing };
}
